import { polymorphicFactory, Box, DsmColor, Grid, Flex, AspectRatioKeeper, Video, Image, PhotoOverlay, GridColumn, RevealOnView, Typography, omitText } from '@kohler-dsm-library/kohler-core';
import { clsx } from 'clsx';
import React, { isValidElement } from 'react';
import classes from './FullBleedExperience.module.css.mjs';
import { getFullBleedExperienceTextPositionClass } from './FullBleedExperience.utils.mjs';

const FullBleedExperience = polymorphicFactory(
  (props, ref) => {
    const {
      component = "section",
      mod,
      heading,
      copy,
      image,
      video,
      textPlacement = "bottom-middle",
      hasPhotoOverlay = true,
      gradientDirection = "tint",
      opacity = 35,
      className,
      ...rest
    } = props;
    const { reveal: headingReveal, ...headingForTypography } = heading ?? {};
    const { reveal: copyReveal, ...copyForTypography } = copy ?? {};
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        component,
        ref,
        mod,
        backgroundColor: DsmColor.BackgroundPrimary,
        className: clsx("kohler-full-bleed-experience-root", classes.fullBleedExperience, className),
        position: "relative",
        ...rest
      },
      /* @__PURE__ */ React.createElement(Grid, null, (video || image) && /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.fullBleedExperienceMediaWrapper) }, /* @__PURE__ */ React.createElement(AspectRatioKeeper, { className: clsx(classes.fullBleedExperienceImageAspectRatio), width: "100%" }, video ? /* @__PURE__ */ React.createElement(
        Video,
        {
          controls: false,
          decorative: true,
          loop: true,
          muted: true,
          autoPlay: true,
          playsInline: true,
          autoplayInView: true,
          ...video
        }
      ) : image && /* @__PURE__ */ React.createElement(Image, { ...image }), /* @__PURE__ */ React.createElement(PhotoOverlay, { direction: gradientDirection, opacity: hasPhotoOverlay ? opacity : void 0, zIndex: 0 }))), heading && copy && /* @__PURE__ */ React.createElement(
        GridColumn,
        {
          className: clsx(classes.fullBleedExperienceContentWrapper, getFullBleedExperienceTextPositionClass(classes, textPlacement))
        },
        /* @__PURE__ */ React.createElement(RevealOnView, { ...headingReveal }, /* @__PURE__ */ React.createElement(
          Typography,
          {
            component: heading.component || "h2",
            textColor: DsmColor.ContentOnPhoto,
            ...omitText(headingForTypography),
            size: "h2",
            className: clsx(classes.fullBleedExperienceContentHeading, heading.className)
          },
          heading.text
        )),
        /* @__PURE__ */ React.createElement(RevealOnView, { ...copyReveal }, /* @__PURE__ */ React.createElement(
          Typography,
          {
            component: isValidElement(copy.text) ? "div" : copy.component || "p",
            ...omitText(copyForTypography),
            size: "paragraph-large",
            className: clsx(classes.fullBleedExperienceContentCopy, copy.className)
          },
          copy.text
        ))
      ))
    );
  }
);

export { FullBleedExperience };
